// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.my-swal-container {
  z-index: 10000;
}

.button-success {
  background-color: var(--blue) !important;
  border: none;
  border-color: var(--blue) !important;
  color: #fff;
  height: 2.8rem;
  min-width: 5rem;
  border-radius: 8px;
  text-transform: uppercase;
  gap: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  padding: 0.5rem 1rem;
  cursor: pointer;
}

.button-error {
  background-color: #f44336;
  border: none;
  border-color: #d32f2f;
  color: #fff;
  height: 2.8rem;
  min-width: 5rem;
  border-radius: 8px;
  text-transform: uppercase;
  gap: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  padding: 0.5rem 1rem;
  cursor: pointer;
  margin-left: 1rem;
}
.bill-details-wrapper {
  padding: 1rem;
  /* min-height: 30vh; */
  overflow-y: scroll;
}
.bill-details-wrapper::-webkit-scrollbar {
  width: 5px;
}

.bill-details-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.bill-details-wrapper::-webkit-scrollbar-thumb {
  background: #888;
}

.bill-details-wrapper::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.order-details-bill-no {
  display: flex;
  justify-content: space-between;
  text-align: left !important;
}

.order-details-bill-details {
  display: flex;
  justify-content: space-between;
  text-align: left;
  position: sticky !important;
}

.order-details-cashier {
  display: flex;
  justify-content: flex-start;
}

.gst-slab {
  font-weight: bold !important;
  font-size: 12px !important;
  letter-spacing: 0.5px;
}

.order-item-list-box {
  font-size: 13px !important;
}

.order-item-table-row td {
  font-size: 13px !important;
  text-align: left !important;
}

.order-item-table-footer td {
  font-weight: bold;
  text-align: left !important;
}

.order-details-divider {
  font-size: 13.6px !important;
  font-weight: bold;
}

.order-details-btns-main {
  display: flex;
  justify-content: space-between;
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 100;
  padding: 10px !important;
  background-color: white !important;
}

.dark .order-details-btns-main {
  background-color: var(--dark-blue) !important;
}

.order-details-btns {
  background-color: rgb(1, 100, 254) !important;
}

.order-details-btns-I {
  background-color: rgb(1, 100, 254) !important;
  margin-right: 10px !important;
}

.loader-order-details-page {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
  width: 100%;
}

.dark .MuiTablePagination-displayedRows {
  color: #fff !important;
}

.dark .MuiTablePagination-actions {
  color: #fff !important;
}

.dark .MuiDataGrid-columnHeaderTitle {
  color: #fff !important;
  font-weight: 600;
  font-size: 0.8rem;
}

.light .MuiDataGrid-columnHeaderTitle {
  color: #000 !important;
  font-weight: 600;
  font-size: 0.8rem;
}

.order-details-btns-back {
  background-color: rgb(1, 100, 254) !important;
  margin-left: 10px !important;
}

.paid-text-order {
  color: green !important;
  font-weight: 600 !important;
  text-align: center !important;
}

.payment-not-done-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  /* height: 200px; */
}

.order-item-table-header {
  font-size: 14px !important;
}
.order-item-table-header th {
  text-align: left !important;
}

.board-header-box {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.board-header-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  border: 1px solid #dbdbdb;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/delivery/components/BillDetails.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,YAAY;EACZ,oCAAoC;EACpC,WAAW;EACX,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,QAAQ;EACR,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,WAAW;EACX,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,QAAQ;EACR,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;EAC7C,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,6CAA6C;EAC7C,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B","sourcesContent":[".my-swal-container {\n  z-index: 10000;\n}\n\n.button-success {\n  background-color: var(--blue) !important;\n  border: none;\n  border-color: var(--blue) !important;\n  color: #fff;\n  height: 2.8rem;\n  min-width: 5rem;\n  border-radius: 8px;\n  text-transform: uppercase;\n  gap: 2px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: bold;\n  padding: 0.5rem 1rem;\n  cursor: pointer;\n}\n\n.button-error {\n  background-color: #f44336;\n  border: none;\n  border-color: #d32f2f;\n  color: #fff;\n  height: 2.8rem;\n  min-width: 5rem;\n  border-radius: 8px;\n  text-transform: uppercase;\n  gap: 2px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: bold;\n  padding: 0.5rem 1rem;\n  cursor: pointer;\n  margin-left: 1rem;\n}\n.bill-details-wrapper {\n  padding: 1rem;\n  /* min-height: 30vh; */\n  overflow-y: scroll;\n}\n.bill-details-wrapper::-webkit-scrollbar {\n  width: 5px;\n}\n\n.bill-details-wrapper::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n.bill-details-wrapper::-webkit-scrollbar-thumb {\n  background: #888;\n}\n\n.bill-details-wrapper::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n.order-details-bill-no {\n  display: flex;\n  justify-content: space-between;\n  text-align: left !important;\n}\n\n.order-details-bill-details {\n  display: flex;\n  justify-content: space-between;\n  text-align: left;\n  position: sticky !important;\n}\n\n.order-details-cashier {\n  display: flex;\n  justify-content: flex-start;\n}\n\n.gst-slab {\n  font-weight: bold !important;\n  font-size: 12px !important;\n  letter-spacing: 0.5px;\n}\n\n.order-item-list-box {\n  font-size: 13px !important;\n}\n\n.order-item-table-row td {\n  font-size: 13px !important;\n  text-align: left !important;\n}\n\n.order-item-table-footer td {\n  font-weight: bold;\n  text-align: left !important;\n}\n\n.order-details-divider {\n  font-size: 13.6px !important;\n  font-weight: bold;\n}\n\n.order-details-btns-main {\n  display: flex;\n  justify-content: space-between;\n  position: sticky;\n  top: 0;\n  width: 100%;\n  z-index: 100;\n  padding: 10px !important;\n  background-color: white !important;\n}\n\n.dark .order-details-btns-main {\n  background-color: var(--dark-blue) !important;\n}\n\n.order-details-btns {\n  background-color: rgb(1, 100, 254) !important;\n}\n\n.order-details-btns-I {\n  background-color: rgb(1, 100, 254) !important;\n  margin-right: 10px !important;\n}\n\n.loader-order-details-page {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 80vh;\n  width: 100%;\n}\n\n.dark .MuiTablePagination-displayedRows {\n  color: #fff !important;\n}\n\n.dark .MuiTablePagination-actions {\n  color: #fff !important;\n}\n\n.dark .MuiDataGrid-columnHeaderTitle {\n  color: #fff !important;\n  font-weight: 600;\n  font-size: 0.8rem;\n}\n\n.light .MuiDataGrid-columnHeaderTitle {\n  color: #000 !important;\n  font-weight: 600;\n  font-size: 0.8rem;\n}\n\n.order-details-btns-back {\n  background-color: rgb(1, 100, 254) !important;\n  margin-left: 10px !important;\n}\n\n.paid-text-order {\n  color: green !important;\n  font-weight: 600 !important;\n  text-align: center !important;\n}\n\n.payment-not-done-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* height: 200px; */\n}\n\n.order-item-table-header {\n  font-size: 14px !important;\n}\n.order-item-table-header th {\n  text-align: left !important;\n}\n\n.board-header-box {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n.board-header-icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 35px;\n  height: 35px;\n  border-radius: 50%;\n  border: 1px solid #dbdbdb;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
